export enum UserRoleId {
  SuperAdmin = 1,
  Admin = 2,
  LHPHAdmin = 3,
  LHPHUser = 4,
  DealerAdmin = 5,
  DealerUser = 6,
  Guest = 7,
  // 8 was Terry, retired 2026-10-19 (lhphcapital-7xvj). Do not reuse the id.
}

// Helper constants for common role groups
export const ADMIN_ROLE_IDS = new Set([
  UserRoleId.SuperAdmin,
  UserRoleId.Admin,
  UserRoleId.LHPHAdmin,
]);

export const LHPH_ROLE_IDS = new Set([UserRoleId.LHPHAdmin, UserRoleId.LHPHUser]);

export const DEALER_ROLE_IDS = new Set([UserRoleId.DealerAdmin, UserRoleId.DealerUser]);

export const GUEST_IDS = new Set([UserRoleId.Guest]);
